import { useMutation, useQueryClient } from "@tanstack/react-query"
import axios from "axios"
import { CreateCheckoutLinkResponseDataSchema, CreateTopupsSetupSchema, DataResponse } from "schema"
import { z } from "zod"
import { getSubscriptionQueryKey } from "../lib/subscriptionQuery"

type Props = z.infer<typeof CreateTopupsSetupSchema>
type Response = DataResponse<z.infer<typeof CreateCheckoutLinkResponseDataSchema>>

export function useCreateTopupsSetupMutation() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (data: Props) => {
      const response = await axios.post<Response>("/billing/checkout/topups", data)
      return response.data.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: getSubscriptionQueryKey() })
    },
  })
}
